import { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiPost } from '../lib/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setErr(null);
    try {
      await apiPost('/api/auth/forgot', { email });
      setDone(true);
    } catch (e2) {
      setErr(e2 instanceof Error ? e2.message : 'Erreur');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-soft)',
      }}
    >
      <div style={{ width: 360, padding: 32, background: 'var(--bg)', borderRadius: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <div style={{ textAlign: 'center', marginBottom: 18 }}>
          <img src="/dt-logo.png" alt="Digital Team" className="brand-logo" style={{ height: 50 }} />
          <h1 style={{ fontSize: 'var(--fs-md)', fontWeight: 600, marginTop: 12 }}>Mot de passe oublié</h1>
          <p style={{ fontSize: 'var(--fs-sm)', color: 'var(--text-mute)', marginTop: 4 }}>
            Saisissez votre email professionnel — vous recevrez un lien sécurisé valable 30 minutes.
          </p>
        </div>

        {done ? (
          <div>
            <div
              style={{
                padding: 12,
                background: 'var(--success-soft)',
                color: 'var(--success-text)',
                borderRadius: 6,
                fontSize: 'var(--fs-sm)',
                marginBottom: 16,
              }}
            >
              Si votre compte existe, un email vous a été envoyé. Vérifiez aussi vos spams.
            </div>
            <Link to="/login" style={{ fontSize: 'var(--fs-sm)' }}>
              ← Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} style={{ display: 'grid', gap: 12 }}>
            <label style={{ display: 'grid', gap: 4 }}>
              <span style={{ fontSize: 'var(--fs-xs)', color: 'var(--text-mute)' }}>E-mail</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                style={{
                  padding: '10px 12px',
                  border: '1px solid var(--border)',
                  borderRadius: 6,
                  fontSize: 'var(--fs-base)',
                }}
              />
            </label>
            {err && (
              <div style={{ fontSize: 'var(--fs-sm)', color: 'var(--danger)', background: 'var(--danger-soft)', padding: 10, borderRadius: 6 }}>
                {err}
              </div>
            )}
            <button type="submit" disabled={submitting} className="btn primary" style={{ marginTop: 4 }}>
              {submitting ? 'Envoi…' : 'Envoyer le lien'}
            </button>
            <div style={{ textAlign: 'center', marginTop: 4 }}>
              <Link to="/login" style={{ fontSize: 'var(--fs-xs)' }}>
                ← Retour à la connexion
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
